import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { StatusLayout } from '../Layout';


function StatusTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const combinedLayouts = [
        { name: 'StatusLayout', layout: StatusLayout },
    ];
    
    const updatedLayouts = combinedLayouts.map(({ name, layout }) => {
        if (name !== 'StatusLayout') {
            return layout.map(group => ({
                ...group,
                label: "", 
                fields: group.fields.map(field => ({
                    ...field,
                    visible: false
                }))
            }));
        }
        return layout;
    });
    
    const finalLayout = updatedLayouts.flat();

    const handleStatusFormLoad = useCallback(() => {
        props.statusFormLookupsLoad(formRefs);

    }, []);

    useEffect(() => {
        
    }, [props.formFields]);

    const handleSelectionChange = useCallback((name, value,e) => {
        props.handleStatusFieldChange(name, value?.selectedItem?.id,formRefs);
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='4A39C46A-36DE-44C6-839B-D8796B3427E3'
                layoutName='WMItemDataEntryStatusForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleStatusFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(StatusTab);
